import { render, staticRenderFns } from "./SamplePalletDetails.vue?vue&type=template&id=2254a596"
import script from "./SamplePalletDetails.vue?vue&type=script&lang=js"
export * from "./SamplePalletDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports